import { render, staticRenderFns } from "./order-status.vue?vue&type=template&id=9045dbc0&scoped=true&"
import script from "./order-status.vue?vue&type=script&lang=js&"
export * from "./order-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9045dbc0",
  null
  
)

export default component.exports